const LIFF = window.liff;
let isInit = false;
let profile = {};
let LIFFInfo = {};

export function init() {
  return new Promise((resolve, reject) => {
    if (!isInit) {
      LIFF.init(
        data => {
          LIFFInfo = data;
          isInit = true;
          resolve();
        },
        err => {
          reject(err);
        }
      );
    } else {
      resolve();
    }
  });
}

export function getLIFFInfo() {
  return LIFFInfo;
}

export function getProfile() {
  return new Promise((resolve, reject) => {
    init()
      .then(() => {
        if (isInit && !profile.userId) {
          LIFF.getProfile()
            .then(pf => {
              profile = pf;
              resolve(profile);
            })
            .catch(err => {
              reject(err);
            });
        } else {
          resolve(profile);
        }
      })
      .catch(err => {
        reject(err);
      });
  });
}

export function sendMessages(message) {
  LIFF.sendMessages([
    {
      type: "text",
      text: message
    }
  ]);
}

export function close() {
  LIFF.closeWindow();
}
